<template>
  <v-app id="app" :style="`backgroundImage: url('${image}')`">
    <router-view />

    <Loader
      :loaderOn="loaderOn"
      :linearLoader="$store.state.loader.linearLoader"
      :circleLoader="$store.state.loader.circleLoader"
    />

    <Snackbar
      :timeout="$store.state.snack.timeout"
      :snackMessage="$store.state.snack.snackMessage"
      :typeSnack="$store.state.snack.typeSnack"
    />

    <ModalMessage
      :message="$store.state.confirmMessage.message"
      :title="$store.state.confirmMessage.title"
      :type="$store.state.confirmMessage.type"
      :btConfirm="$store.state.confirmMessage.btConfirm"
      :btCancel="$store.state.confirmMessage.btCancel"
      :callback="$store.state.confirmMessage.callback"
    />
  </v-app>
</template>

<script>
import Loader from './components/common/Loader'
import Snackbar from './components/common/Snackbar'
import ModalMessage from './components/common/ModalMessage'

export default {
  name: 'App',

  components: {
    Loader,
    Snackbar,
    ModalMessage
  },

  created () {
    if (this.$router.history.current.path !== '/login') {
      this.$store.dispatch('request/verifyAuth').then((resp) => {
        if (!resp) {
          this.$router.push('/login')
        }
      })
    }
  },

  computed: {
    image () {
      return this.$store.state.theme.background
    },

    loaderOn () {
      return this.$store.state.loader.loaderOn
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  /*background: transparent url("../public/img/insight_img_bg_1.jpg") no-repeat
    fixed center;*/
  background-size: cover;
}
.trControls {
  position: absolute;
  background: #fff;
  right: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 2px;
  position: absolute;
  top: calc(100% - 42px);
  right: 5px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
}
.posRelative {
  position: relative !important;
}
.smallSwitch .v-input--switch__track {
  height: 10px !important;
  width: 25px !important;
}
.smallSwitch .v-input--switch__thumb {
  width: 16px !important;
  height: 16px !important;
}
.smallSwitch label {
  font-size: 14px;
  margin-bottom: 4px;
}
</style>
